<template>
  <div
    style="background-color:var(--color-rosa); color:var(--color-braun);"
    class="lg:-mt-80 lg:pt-80"
  >
    <div class="max-w-5xl mx-auto px-5 lg:px-10 py-10 lg:py-32 text-center tracking-widest leading-8">
      <div class="uppercase">
        unsere
      </div>
      <div class="text-5xl md:text-8xl font-bold mb-10 font-['Boska']">
        Speisekarte
      </div>
      <div class="uppercase mb-20">
        Ob süß oder herzhaft, Kaffee oder Kuchen, frisch gebacken oder eisgekühlt - in der Konditorei Genuss Café ist für jeden Geschmack etwas dabei.
      </div>
      <img
        class="w-full"
        src="@/assets/Bilder/Genuss-Cafe-Speisekarte.png"
      >
      <div class="flex gap-4 justify-center flex-col sm:flex-row">
        <a
          class="relative inline-block text-sm font-medium group focus:outline-none focus:ring uppercase"
          style="color:var(--color-braun);"
          href="/Speisekarte/Speisekarte.pdf"
          target="_blank"
          rel="noopener"
        >
          <span class="absolute inset-0 border border-current" />
          <span class="block px-12 py-3 border transition-transform border-current group-hover:-translate-x-1 group-hover:-translate-y-1">
            Speisekarte
          </span>
        </a>
        <a
          class="relative inline-block text-sm font-medium group focus:outline-none focus:ring uppercase"
          style="color:var(--color-braun);"
          href="/Speisekarte/Eiskarte.pdf"
          target="_blank"
          rel="noopener"
        >
          <span class="absolute inset-0 border border-current" />
          <span class="block px-12 py-3 border transition-transform border-current group-hover:-translate-x-1 group-hover:-translate-y-1">
            Eiskarte
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu'
}
</script>

<style scoped lang="scss">

</style>
